import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './data/PublicKey';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

//document.body.style.backgroundColor = '#0051ba';
//document.body.style.backgroundColor = '#e5e7eb';

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
